import type { SceneStore } from '@os/doc';
import type { PaletteCommand } from '../palette/commands';
import { pageLabel } from './labels';
import type { PageNav } from './page-nav';

/** The ⌘K entries of pages (P14 Ruling 14): the panel, a new page (editors), back after a link, then one per page. */
export function pageCommands(o: { store: SceneStore; nav: PageNav; t: (key: string, opts?: Record<string, unknown>) => string; openPanel: () => void }): PaletteCommand[] {
  const { store, nav, t } = o;
  const out: PaletteCommand[] = [{ id: 'pages', label: t('pages.title'), group: 'board', keywords: ['pages', 'page'], run: o.openPanel }];
  if (!store.readOnly)
    out.push({
      id: 'newPage',
      label: t('pages.new'),
      group: 'board',
      keywords: ['page', 'ajouter', 'add'],
      run: () => {
        const id = store.commands.addPage({ after: store.page });
        if (id) nav.go(id);
      },
    });
  if (nav.canGoBack) out.push({ id: 'pageBack', label: t('pages.back'), group: 'navigate', keywords: ['page', 'retour', 'back'], run: () => void nav.back() });
  store.pages().forEach((p, i) => {
    if (p.id === store.page) return;
    out.push({ id: `page:${p.id}`, label: t('pages.goTo', { name: pageLabel(t, p, i) }), group: 'navigate', keywords: ['page'], run: () => nav.go(p.id) });
  });
  return out;
}
